import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {ReleaseInfo, ArtistInfo, SampleByArtist} from 'decentralized/EthereumEvents.js';
import ArtistsContract from 'decentralized/contracts/ArtistsContract.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import {web3} from 'decentralized/web3.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {ARTISTS} from 'decentralized/transactions/contracts.js';

const contractAddress = new ArtistsContract().contractAddress;

export const getReleases = async (discogsIds) => {
    let query = new BackendQuery(contractAddress)
        .from(ReleaseInfo)
        .select("artistName")
        .select("releaseName")
        .select("releaseType")
        .select("coverArtHash")
        .whereIn("releaseId", discogsIds);
    let results = await query.executeQuery();
    let releases = {};
    for (let result of results) {
        if (result.releaseName.startsWith("RECORD")) {
            result.releaseName = result.releaseName.slice(7);
        }
        if (result.releaseName.startsWith("SAMPLE_PACK")) {
            result.releaseName = result.releaseName.slice(12);
        }
        releases[result.releaseId] = result;
    }
    return releases;
};

export const getArtistForSample = async (ipfsHash) => {
   let query = new BackendQuery(contractAddress)
        .from(SampleByArtist)
        .select("artistName")
        .where("ipfsHash", ipfsHash);
    let results = await query.executeQuery();
    if (results.length === 0) {
        return undefined;
    }
    results.reverse();
    return results[0].artistName;
};

export const getArtistInfo = async (artistName) => {
  let query = new BackendQuery(contractAddress)
        .from(ArtistInfo)
        .select("artistName")
        .select("linkType")
        .select("link")
        .where("artistName", artistName);
    let results = await query.executeQuery();
    if (results.length === 0) {
        return undefined;
    }
    results.reverse();
    return results[0];
}

export const getRelease = async (discogsId) => {
    let query = new BackendQuery(contractAddress)
        .from(ReleaseInfo)
        .select("artistName")
        .select("releaseName")
        .select("releaseType")
        .select("coverArtHash")
        .where("releaseId", discogsId);
    let results = await query.executeQuery();
    return results[0];
};

export const newSampleByArtist = async (
    artistName,
    sampleIpfs
) => {
    console.log('newSampleByArtist(%s,%s)', artistName, sampleIpfs)
    await new EthereumTransaction(
        ARTISTS,
        'newSampleByArtist',
        [
            web3.utils.fromAscii(artistName),
            ipfsHashToBytes32(sampleIpfs),
        ])
        .execute();
};

export const newRelease = async (
    artistName,
    releaseId,
    releaseName,
    coverArtHash,
    releaseType='RECORD') => {
        console.log('newRelease(%s,%s,%s,%s,%s)', artistName, releaseId, releaseName, coverArtHash, releaseType)
        await new EthereumTransaction(
            ARTISTS,
            'newRelease',
            [
                web3.utils.fromAscii(artistName),
                releaseId,
                releaseName,
                ipfsHashToBytes32(coverArtHash),
                web3.utils.fromAscii(releaseType)
            ])
            .execute();

};

export const newArtistInfo = async (
    artistName,
    linkType,
    link) => {
        console.log('newArtistInfo(%s,%s,%s,%s,%s)', artistName, linkType, link)
        await new EthereumTransaction(
            ARTISTS,
            'newArtistInfo',
            [
                web3.utils.fromAscii(artistName),
                web3.utils.fromAscii(linkType),
                link
            ])
            .execute();
};


export const getSamplePack = async (artist, packName) => {
    let item = window.sessionStorage.getItem("getSamplePack(" + artist + ',' + packName  + ")");
    if (item) {
        console.log("item =", item);
        return JSON.parse(item);
    }
    let query = new BackendQuery(contractAddress)
        .from(ReleaseInfo)
        .select("artistName")
        .select("releaseName")
        .select("discogsId")
        .select("releaseType")
        .select("coverArtHash")
        .where("artistName", artist);

    let results = await query.executeQuery();
    console.log("SAMPLE PACK RESULTS =", results);
    let x = results.find(x => x.releaseName.includes(packName));
    if (x) {
        x.releaseName = x.releaseName.slice(12);
        return x;
    }
    return undefined;
};
